function init() {
	if (!$.modal.isActive()) {
		var $redirectPopup = document.getElementById("redirect-popup");
		if ($redirectPopup && $($redirectPopup).attr("data-show-popup") === "True") {
			$($redirectPopup).modal({
				closeExisting: true,
			});
		}
	}
}

export default {
	view: "redirectPopupBlock",
	init,
};
